import React, { useState } from 'react'
import styles from '../../Components/Time/Time.module.css'
import { useTranslation } from "react-i18next";
import TimeForPackage from '../../Components/TimeForPackage/TimeForPackage'
import { useLocation } from 'react-router-dom';


const TimeForPackagePage = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { details, servicesCard,header ,header2, ServiceStatus, isEdit, employeeNumber, startDateFromEdit, service, servicesId2 } = location.state || {}; // Get card data from navigation state
  console.log("header",header)
  return (
    <div className='flex-grow-1'>

    <div className={styles.loginContainer}>
    <div className={styles.loginHeader}> {t('time')}</div>
    <div className={styles.loginSecHeader}>{t('select_available_times')}</div>


      </div>

      <TimeForPackage 
                      details={details} 
                      servicesCard={servicesCard} 
                      header={header} 
                      header2={header2} 
                      ServiceStatus={ServiceStatus} 
                      isEdit={isEdit}
                      employeeNumber={employeeNumber}
                      startDateFromEdit={startDateFromEdit}
                      service={service}
                      servicesId2={servicesId2}
                      />
      
    </div>
  )
}
export default TimeForPackagePage;
